var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.totalHits > 0)?_c('div',{staticClass:"hiq-calendar-archive__hits-amount"},[_c('p',[_vm._v(" Det finns "),(_vm.totalHits === 1)?_c('strong',[_vm._v(_vm._s(`${_vm.totalHits} kalenderhändelse `))]):_c('strong',[_vm._v(_vm._s(`${_vm.totalHits} kalenderhändelser `))]),_vm._v(" i kalendern. ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }